<div class="affichage-bureaux">
	@if (longueurParent() !== 0 && hauteurParent() !== 0) {
		<app-grid-ilots
				[ilots]="[ilot()]"
				[duree]="duree()"
				[longueurParent]="longueurParent()"
				[hauteurParent]="hauteurParent()"
				[readonly]="readonly()"
				[estAffichagePlusieursIlots]="false"
				[labelHaut]="labelHaut()"
				[labelDroite]="labelDroite()"
				[labelBas]="labelBas()"
				[labelGauche]="labelGauche()"
				[estAffichageVertical]="estAffichageVertical()"
				[estAfficherLabelIlot]="true"
				[bureauPreferentielId]="bureauPreferentielId()"
				[utilisateurConnecte]="utilisateurConnecte()"
				(onClickBureau)="onClickBureau($event)"/>
	}

	@if (!readonly() && isNotNullOrUndefined(bureauSelectionne())) {
		<app-reserver-bureau-modal
				[visible]="showReserverBureauModal()"
				[bureau]="bureauSelectionne()"
				[dateReservation]="dateReservation()"
				[duree]="dureeReservation()"
				[ilot]="ilot()"
				(visibleChange)="showReserverBureauModal.set($event)"/>
	}
</div>
